import { APP_URLS } from 'constants/urls';
import { BreadCrumbsOptions } from './types';
import getDashboardHomeItem from './dashboardHomeItem';

export default function getDocumentationBreadcrumbMap({
  pathname,
  t,
  entity,
}: BreadCrumbsOptions) {
  const dashboardHomeItem = getDashboardHomeItem({ t });
  const documentationItem = {
    label: t('documentation'),
    path: APP_URLS.dashboard.documentation.index.getPathWithQuery(),
  };

  return [
    {
      condition:
        APP_URLS.dashboard.documentation.index.isTheSameUrlAs(pathname),
      data: [dashboardHomeItem, { label: t('documents') }],
    },
    {
      condition:
        APP_URLS.dashboard.documentation.analytics.isTheSameUrlAs(pathname),
      data: [dashboardHomeItem, documentationItem, { label: t('analytics') }],
    },
    {
      condition:
        APP_URLS.dashboard.documentation.approvals.isTheSameUrlAs(pathname),
      data: [dashboardHomeItem, documentationItem, { label: t('approvals') }],
    },
    {
      condition:
        APP_URLS.dashboard.documentation.categories.isTheSameUrlAs(pathname),
      data: [dashboardHomeItem, documentationItem, { label: t('categories') }],
    },
    {
      condition: APP_URLS.dashboard.documentation.add.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        documentationItem,
        { label: t('create-document') },
      ],
    },
    {
      condition:
        APP_URLS.dashboard.documentation.import.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        {
          label: t('documents'),
          path: APP_URLS.dashboard.documentation.index.getPathWithQuery(),
        },
        { label: t('import-documents') },
      ],
    },
    {
      condition: APP_URLS.dashboard.documentation.edit.isTheSameUrlAs(
        pathname,
        {
          pathParts: { id: `${entity?.id}` },
        },
      ),
      data: [
        dashboardHomeItem,
        documentationItem,
        { label: t('edit-document') },
      ],
    },
    {
      condition: APP_URLS.dashboard.documentation.view.isTheSameUrlAs(
        pathname,
        {
          pathParts: { id: `${entity?.id}` },
        },
      ),
      data: [
        dashboardHomeItem,
        documentationItem,
        { label: entity?.name || t('document') },
      ],
    },
    {
      condition: APP_URLS.dashboard.documentation.createVersion.isTheSameUrlAs(
        pathname,
        {
          pathParts: { id: `${entity?.id}` },
        },
      ),
      data: [
        dashboardHomeItem,
        documentationItem,
        {
          label: entity?.name || t('document'),
          path: APP_URLS.dashboard.documentation.view.getDynamicPath({
            pathParts: { id: `${entity?.id}` },
          }),
        },
        { label: t('create-new-version') },
      ],
    },
  ];
}
